import { JSX } from 'preact';

type IImageProps = JSX.IntrinsicElements['img'] & {
	fallbackImage?: string;
};

const Image = ({ fallbackImage, src, alt, ...rest }: IImageProps) => {
	const handleError = (event: JSX.TargetedEvent<HTMLImageElement, Event>) => {
		if (fallbackImage) {
			event.currentTarget.src = fallbackImage;
		}
	};

	return <img src={src} alt={alt} onError={handleError} {...rest} />;
};

export default Image;
